import { useContext } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useQuery, useMutation } from "@apollo/client"

// Context
import { UserContext } from "../../context/userContext"

// Component
import FormUser from "./Form/FormUser"
import FormPartner from "./Form/FormPartner"
import ROUTES from "../../components/Routes/routesContants"

import { LoaderMedium } from "../../components/Loaders"
// Queries
import { GET_USERS, GET_USER, EDIT_USER } from "./queries"

export default function EditUser() {
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const { idUser } = useParams()

  const mutationVariables = {
    staff_id: userCtx.session.user.staff_id,
    organization_id: userCtx.session.user.organization_id,
  }

  const { data, loading } = useQuery(GET_USER, {
    variables: {
      staff_id: idUser,
    },
    context: {
      headers: {
        // "user": JSON.stringify(user)
      },
    },
    skip: !userCtx.session.user.staff_id,
    fetchPolicy: "network-only",
  })

  const [editUser] = useMutation(EDIT_USER, {
    variables: mutationVariables,
    refetchQueries: [
      {
        query: GET_USERS,
        variables: {
          staff_id: userCtx.session.user.staff_id,
          organization_id: userCtx.session.user.organization_id,
        },
      },
    ],
    onCompleted: () => navigate(ROUTES.USER_LIST),
  })

  if (loading) return <LoaderMedium />

  return (
    <div>
      <h1>Edit Member</h1>
      {userCtx.session.user.organization_type === "STAFF" && (
        <FormUser fields={data.user} onSubmitHandler={editUser} />
      )}
      {userCtx.session.user.organization_type === "PARTNER" && (
        <FormPartner fields={data.user} onSubmitHandler={editUser} />
      )}
    </div>
  )
}
